import axios from "axios";

class EmpreendimentosServiceCrawler {
    constructor() {
        const baseUrl = import.meta.env.VITE_API_MR_CRAWLER_URL;
        this.baseUrlEmpreendimentos = `${baseUrl}api/imoveis`;
        this.baseUrlEmpreendimentosExport = `${baseUrl}api`;
        this.baseUrlEmpreendimentosMetadata = `${baseUrl}api/imoveis-agregated`;
    }

    extractValuesArray = (array) => array.map(item => item);

    extractValuesArrayFromCidade = (array) =>
        array.map(item => item.value.split("-")[1]?.trim());

    /**
     * Função genérica para enviar POSTs
     */
    async postRequest(url, payload) {
        try {
            const { data, headers } = await axios.post(url, payload);
            return {data, headers};
        } catch (error) {
            console.error(`Erro na requisição POST para ${url}:`, error);
            throw error;
        }
    }

    /**
     * Cria o payload base, com suporte a circle, polygon e agrupamento
     */
    buildPayload(state, extras = {}) {
        let {
            tipo_empreendimento,
            padrao,
            area_maior_que,
            area_menor_que,
            quartos,
            vagas,
            tipo_negocio,
            valor_menor_que,
            valor_maior_que,
            valor_metro_maior_que,
            valor_metro_menor_que,
            cidade,
            estado,
            bairros,
            get_meta_data,
        } = state;

        cidade = this.extractValuesArrayFromCidade(cidade || []);
        let bairro = this.extractValuesArray(bairros || []);
        tipo_negocio = tipo_negocio?.value || tipo_negocio || "";
        quartos = (quartos && quartos.length > 0) ? quartos : [];

        return {
            tipo: tipo_empreendimento,
            padrao,
            cidade,
            estado,
            bairro,
            area_maior_que,
            area_menor_que,
            quartos,
            vagas,
            tipo_negocio,
            valor_menor_que,
            valor_maior_que,
            valor_metro_maior_que,
            valor_metro_menor_que,
            get_meta_data,
            ...extras
        };
    }

    async getEmpreendimento(id) {
        try {
            const { data } = await axios.get(`${this.baseUrlEmpreendimentos}/${id}`);
            return data;
        } catch (error) {
            console.error("Erro ao buscar empreendimento:", error);
        }
    }

    async getEmpreendimentosWithinRadius(latitude, longitude, radius, state) {
        const payload = this.buildPayload(state, {
            circle: { radius, latitude, longitude }
        });
        return this.postRequest(this.baseUrlEmpreendimentos, payload);
    }

    async getEmpreendimentosWithinPolygon(geoJsonPolygon, state) {
        const payload = this.buildPayload(state, { polygon: geoJsonPolygon });
        return this.postRequest(this.baseUrlEmpreendimentos, payload);
    }

    async getMetadataWithinPolygon(geoJsonPolygon, state, agrupamento) {
        const payload = this.buildPayload(state, {
            polygon: geoJsonPolygon,
            agrupamento
        });
        return this.postRequest(this.baseUrlEmpreendimentosMetadata, payload);
    }

      async getEmpreendimentoOnCidade(state, agrupamento) {
        const payload = this.buildPayload(state, { agrupamento });
        return this.postRequest(this.baseUrlEmpreendimentos, payload);
    }

    async getMetadataWithinCidade(state, agrupamento) {
        const payload = this.buildPayload(state, { agrupamento });
        return this.postRequest(this.baseUrlEmpreendimentosMetadata, payload);
    }

    async exportExcel(queryID) {
        const user_id = document.querySelector('#user_id').value;
        const isCliente = document.querySelector('#isCliente').value == 1;

        const payload = { user_id, query_id: queryID, isCliente };
        return this.postRequest(`${this.baseUrlEmpreendimentosExport}/imoveis-export`, payload);
    }
}

export default new EmpreendimentosServiceCrawler();
